/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import './../styles/style.scss';

/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import Gallery from './classes/gallery';
import Breakpoint from './classes/breakpoint';
import VideoEmbed from './classes/video';
import Accordion from './classes/accordion';
import Filters from './classes/filters';
import HoverTargets from './classes/hover-targets';
import DesktopImage from './classes/desktop-image';
import ScrollLocker from './classes/scroll-locker';
import AccordionGrid from './classes/accordion-grid';
import Uploader from './classes/uploader';
import ScrollControl from './classes/scroll';
import PlaceholderLabels from './classes/placeholder-labels';

/*------------------------------------------------------------------
Import external modules
------------------------------------------------------------------*/

import { attach, nodeArray, drawSVG, Event, offset } from 'meteora';
import Equalizer from '@meteora-digital/equalizer';
// import Parallax from 'background-parallax';
import MagicScrolls from 'magic-scrolls';
import each from './functions/each';
import inView from 'in-view';

/*------------------------------------------------------------------
Import components
------------------------------------------------------------------*/

import './components/intro';
import './components/banner';
import './components/maps';
import './components/header';
import './components/macy';
import './components/application';
import './components/quote';
import './components/location';
import './components/selectors';
import './components/tool-tips';
import './components/forms';

/*------------------------------------------------------------------
Import page
------------------------------------------------------------------*/

import './pages/careers';
import './pages/quarries';

/*------------------------------------------------------------------
Import blocks
------------------------------------------------------------------*/

import './blocks/steps-block';

/*------------------------------------------------------------------
Helpers
------------------------------------------------------------------*/

/*------------------------------------------------------------------
Global
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  window.ScrollControl = new ScrollControl();
  window.ScrollLocker = new ScrollLocker(document.querySelector('.body'));

  // equal heights
  each('[data-equalize]', function (el) {
    return el.Equalizer = new Equalizer(el);
  });

  // dynamic breakpoints
  each('[data-breakpoint]', function (el) {
    return new Breakpoint(el);
  });

  // gallery items
  each('.js-gallery', function (el) {
    return new Gallery(el);
  });

  // setup drawSVG
  each('.js-draw-svg svg', function (svg) {
    return drawSVG(svg);
  });

  // in view animations
  inView('.js-in-view').on('enter', function (el) {
    setTimeout(function () {
      el.classList.add('in-view');
    }, 500);
  });
  inView('.js-draw-svg svg').on('enter', function (svg) {
    setTimeout(function () {
      svg.draw(2500);
    }, 500);
  });
  each('[data-parallax]', function (section) {
    var magic = new MagicScrolls(section, {
      duration: 600
    });
    nodeArray(section.querySelectorAll('[data-parallax-watch]')).forEach(function (el) {
      return magic.parallax(el);
    });
  });

  // videos
  each('[data-video]', function (video) {
    var embed = new VideoEmbed(video.getAttribute('data-video'));
    video.addEventListener('click', function (e) {
      e.preventDefault();
      video.innerHTML = embed.render();
    });
  });

  // background videos
  each('[data-background-video]', function (video) {
    var embed = new VideoEmbed(video.getAttribute('data-background-video'), {
      mute: 1,
      loop: 1
    });
    var iframe;
    if (window.innerWidth >= 1024) {
      video.innerHTML = embed.render();
      iframe = video.querySelector('iframe');
      attach(window, 'resize', function () {
        if (iframe.clientHeight < iframe.parentNode.clientHeight) {
          iframe.style.width = '100%';
          iframe.style.height = "".concat(Math.round(iframe.clientWidth * 0.5625), "px");
        } else {
          iframe.style.height = '100%';
          iframe.style.width = "".concat(Math.round(iframe.clientHeight * 1.7777777778), "px");
        }
      }, 500);
    }
  });

  // uploaders
  each('input[type="file"]', function (input) {
    return new Uploader(input);
  });

  // accordions
  each('.js-accordion', function (el) {
    return new Accordion(el);
  });
  each('.js-accordion-grid', function (el) {
    return el.AccordionGrid = new AccordionGrid(el);
  });

  // filters
  each('.js-filter', function (el) {
    return new Filters(el);
  });

  // hover actions
  each('.js-mega-menu', function (el, i) {
    var menu = new HoverTargets(el, function (target, info) {
      target.classList.add('js-active');
      nodeArray(target.parentNode.querySelectorAll('[data-hover-target]')).forEach(function (sibling) {
        if (sibling !== target) sibling.classList.remove('js-active');
      });
    });
  });
  each('.js-mega-trigger', function (el, i) {
    var links = nodeArray(el.parentNode.querySelectorAll('[data-hover]'));
    var first = links[0];
    var hover = new Event('mouseenter');
    var active = links.filter(function (link) {
      return link.classList.contains('current') || link.classList.contains('section');
    })[0];
    var init = function init() {
      if (active) {
        active.classList.add('js-active');
      } else if (first) {
        first.dispatchEvent(hover);
        first.classList.add('js-active');
      }
      ;
    };
    links.forEach(function (link) {
      var siblings = nodeArray(link.parentNode.parentNode.querySelectorAll('[data-hover]')).filter(function (l) {
        return l != link;
      });
      link.addEventListener('mouseenter', function () {
        link.classList.add('hover');
        siblings.forEach(function (sibling) {
          return sibling.classList.remove('hover');
        });
        // links.filter((l) => l != link).forEach((l) => );
        if (active) {
          active.classList.remove('js-active');
        } else if (first) {
          first.classList.remove('js-active');
        }
      });
    });
    el.addEventListener('mouseenter', function () {
      return init();
    });
  });

  // desktop styles
  each('[desktop-image]', function (el) {
    return new DesktopImage(el);
  });

  // form validation
  // each('.js-form form', (form = false) => {
  //   if (form) {
  //     new PlaceholderLabels(form);
  //     const validation = new FormValidation(form);
  //     const message = form.querySelector('.message')

  //     form.querySelector('input[type="submit"]').addEventListener('click', (e) => {
  //       e.preventDefault();

  //       validation.submit((e) => {
  //         console.log(e);
  //         let response = JSON.parse(e);
  //         let selects = nodeArray(form.querySelectorAll('select'));

  //         message.innerHTML = response.message;
  //         message.classList.add('success');

  //         selects.forEach((select) => {
  //           let selector = select.previousElementSibling;
  //           selector.querySelector(`.${selector.className}__placeholder`).innerHTML = select.firstElementChild.text;
  //         });

  //         window.ScrollControl.scrollTo(offset(form).y - 200, 1000);

  //         if (form.DuplicatingFields) form.DuplicatingFields.removeDuplicates();
  //       });
  //     });
  //   }
  // });
});